import styled from 'styled-components';

export const transitionSpeed = 200;

export const Styled = styled.div`
  margin-top: 20px;

  .Card {
    transition:
      all ${transitionSpeed}ms ease,
      height ${transitionSpeed / 2}ms ease-out;
    > div {
      transition: opacity ${transitionSpeed}ms ease;
      will-change: opacity;
    }
    &.-enter,
    &.-exit {
      > div {
        opacity: 1;
      }
    }
    &.-enter-active,
    &.-exit-active {
      > div {
        opacity: 0;
      }
    }
  }

  &.collectionDateTimeCard,
  &.deliveryDateTimeCard {
    [ant-click-animating-without-extra-node='true']::after,
    .ant-click-animating-node {
      animation: none;
    }
  }
`;
